export const products = [
  {
    id: 1,
    slug: 'dell-latitude-5420',
    name: 'Dell Latitude 5420',
    brand: 'Dell',
    category: 'laptop',
    image: 'https://public.readdy.ai/ai/img_res/87a2f562e73b74bac3c452f9d9846de4.jpg',
    processor: 'Intel Core i5-11.Nesil',
    ram: '16GB DDR4',
    storage: '512GB SSD',
    condition: 'Sıfır Ayarında',
    price: 18500,
    oldPrice: 22000,
    rating: 5,
    status: 'new',
  },
  {
    id: 2,
    slug: 'hp-elitedesk-800-g5',
    name: 'HP EliteDesk 800 G5',
    brand: 'HP',
    category: 'desktop',
    image: 'https://readdy.ai/api/search-image?query=HP%20EliteDesk%20compact%20desktop%20tower%20computer%20on%20pristine%20white%20background%20professional%20studio%20lighting%20sleek%20black%20chassis%20modern%20business%20workstation%20clean%20minimalist%20product%20shot%20sharp%20details%20commercial%20photography%20style&width=400&height=300&seq=prod2&orientation=landscape',
    processor: 'Intel Core i7-9.Nesil',
    ram: '32GB DDR4',
    storage: '1TB SSD',
    condition: 'Az Kullanılmış',
    price: 24900,
    rating: 5,
    status: 'featured',
  },
  {
    id: 3,
    slug: 'lenovo-thinkpad-x1-carbon',
    name: 'Lenovo ThinkPad X1 Carbon',
    brand: 'Lenovo',
    category: 'laptop',
    image: 'https://readdy.ai/api/search-image?query=Lenovo%20ThinkPad%20X1%20Carbon%20ultrabook%20laptop%20on%20clean%20white%20desk%20surface%20professional%20product%20photography%20matte%20black%20carbon%20fiber%20finish%20open%20laptop%20showing%20display%20soft%20studio%20lighting%20premium%20business%20aesthetic%20high%20end%20commercial%20quality&width=400&height=300&seq=prod3&orientation=landscape',
    processor: 'Intel Core i7-10.Nesil',
    ram: '16GB LPDDR3',
    storage: '512GB NVMe SSD',
    condition: 'Sıfır Ayarında',
    price: 26500,
    oldPrice: 32000,
    rating: 5,
    status: 'new',
  },
  {
    id: 4,
    slug: 'asus-rog-strix-g15',
    name: 'ASUS ROG Strix G15',
    brand: 'ASUS',
    category: 'gaming',
    image: 'https://readdy.ai/api/search-image?query=ASUS%20ROG%20gaming%20laptop%20on%20white%20surface%20with%20RGB%20lighting%20effects%20professional%20product%20photography%20aggressive%20angular%20design%20black%20chassis%20with%20red%20accents%20open%20display%20modern%20gaming%20aesthetic%20studio%20lighting%20commercial%20quality&width=400&height=300&seq=prod4&orientation=landscape',
    processor: 'AMD Ryzen 7 5800H',
    ram: '16GB DDR4',
    storage: '1TB SSD',
    gpu: 'RTX 3060 6GB',
    condition: 'Az Kullanılmış',
    price: 32900,
    rating: 5,
    status: 'featured',
  },
  {
    id: 5,
    slug: 'apple-imac-24-m1',
    name: 'Apple iMac 24" M1',
    brand: 'Apple',
    category: 'desktop',
    image: 'https://readdy.ai/api/search-image?query=Apple%20iMac%2024%20inch%20all%20in%20one%20desktop%20computer%20on%20pure%20white%20background%20professional%20studio%20photography%20colorful%20slim%20design%20vibrant%20display%20modern%20minimalist%20aesthetic%20clean%20product%20shot%20premium%20quality%20commercial%20style&width=400&height=300&seq=prod5&orientation=landscape',
    processor: 'Apple M1 Chip',
    ram: '8GB Unified',
    storage: '256GB SSD',
    condition: 'Sıfır Ayarında',
    price: 38900,
    rating: 5,
    status: 'new',
  },
  {
    id: 6,
    slug: 'msi-gaming-monitor-27',
    name: 'MSI Gaming Monitor 27"',
    brand: 'MSI',
    category: 'monitor',
    image: 'https://readdy.ai/api/search-image?query=MSI%20curved%20gaming%20monitor%2027%20inch%20on%20white%20background%20professional%20product%20photography%20sleek%20black%20bezel%20modern%20stand%20vibrant%20display%20showing%20colorful%20content%20studio%20lighting%20commercial%20quality%20high%20resolution&width=400&height=300&seq=prod6&orientation=landscape',
    specs: '165Hz, 1ms, QHD',
    condition: 'Sıfır Ayarında',
    price: 8900,
    rating: 5,
    status: 'featured',
  },
];

export const productsData = products;